import { ApiClient } from './client.js'
import { FAVOURITE_TRACKS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (favouriteItemId) {
    return client.get(`${FAVOURITE_TRACKS}${favouriteItemId}/`)
  },

  list () {
    return client.get(`${FAVOURITE_TRACKS}`)
  },

  listAll () {
    return client.getAll(`${FAVOURITE_TRACKS}`)
  },

  lite () {
    return client.get(`${FAVOURITE_TRACKS}lite/`)
  },

  liteAll () {
    return client.getAll(`${FAVOURITE_TRACKS}lite/`)
  },

  create (data) {
    return client.post(`${FAVOURITE_TRACKS}`, data)
  },

  delete (favouriteItemId) {
    return client.delete(`${FAVOURITE_TRACKS}${favouriteItemId}/`)
  }
}
